import { NgModule, ModuleWithProviders } from '@angular/core';
import { ErrorHandlerInterceptor } from './error-handler.interceptor';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


@NgModule({
    imports: [NzMessageModule, RouterModule],
    exports: [],
    declarations: [],
    providers: [],
})
export class MmCommonModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: MmCommonModule,
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: ErrorHandlerInterceptor,
                    multi: true
                }
            ]
        }
    }


}
